import { LOAD_EFFECTS } from "../../content/loads.js";

export type CaseLoad = { id: string; weight: number };

export function addCaseLoad(loads: readonly CaseLoad[], id: string): CaseLoad[] {
  if (!LOAD_EFFECTS[id as keyof typeof LOAD_EFFECTS] || loads.some((entry) => entry.id === id)) {
    return [...loads];
  }
  return [...loads, { id, weight: 1 }];
}

export function parseWeightText(text: string): number | null {
  const trimmed = text.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  return Number(trimmed);
}

export function setCaseLoadWeight(loads: readonly CaseLoad[], id: string, weight: number): CaseLoad[] {
  const next = Math.max(0, Math.floor(weight));
  return loads.map((entry) => (entry.id === id ? { ...entry, weight: next } : entry));
}

export function removeCaseLoad(loads: readonly CaseLoad[], id: string): CaseLoad[] {
  return loads.filter((entry) => entry.id !== id);
}

export function unusedLoadIds(loads: readonly CaseLoad[]): string[] {
  const used = new Set(loads.map((entry) => entry.id));
  return Object.keys(LOAD_EFFECTS).filter((id) => !used.has(id));
}

export function loadCaption(id: string): string {
  const effect = LOAD_EFFECTS[id as keyof typeof LOAD_EFFECTS] as {
    name: string;
    fatigue?: number;
    progress?: number;
    nextHandDiscard?: number;
    nextActionDrawLimit?: number;
    addTemporaryCards?: { count: number };
  } | undefined;
  if (!effect) return id;
  const bits: string[] = [];
  if (effect.fatigue) bits.push(`疲労+${effect.fatigue}`);
  if (effect.progress) bits.push(`進捗${effect.progress}`);
  if (effect.nextHandDiscard) bits.push(`手札破棄${effect.nextHandDiscard}`);
  if (effect.nextActionDrawLimit) bits.push(`ドロー制限${effect.nextActionDrawLimit}`);
  if (effect.addTemporaryCards) bits.push(`一時札+${effect.addTemporaryCards.count}`);
  return bits.length ? `${effect.name}（${bits.join("・")}）` : effect.name;
}
